import { pluginFactory } from '@atlaskit/editor-common/utils';
import { rovoAgentsPluginKey } from './plugin-key';
import { reducer } from './reducer';
var _pluginFactory = pluginFactory(rovoAgentsPluginKey, reducer),
  createPluginState = _pluginFactory.createPluginState,
  createCommand = _pluginFactory.createCommand;
export { createPluginState, createCommand };
export var getRovoAgentsPluginState = function getRovoAgentsPluginState(state) {
  var pluginState = rovoAgentsPluginKey.getState(state);
  return pluginState;
};